(() => {
  class ProductCard extends HTMLElement {
    constructor(options) {
      super();

      this.options = { ...options };

      this.cards = qsa('.js-product-card', this);
      this.headerCart = qs('#js-header-cart-count');

      if (!this.cards) return;

      this.init();
    }

    init() {
      this.cardAddCart();
      this.cardWishlist();
      this.cardVariants();
      this.priceLayout();
    }

    cardAddCart() {
      this.cards.forEach((card) => {
        const addButton = qs('.js-product-card-add', card);

        addButton &&
          addButton.addEventListener('click', async (e) => {
            e.preventDefault();
            const success = qs('.js-product-card-success', card);
            let variant_id = qs('input[name="id"]', card).value;
            const isCeramicProduct = qs('input[name="properties[_isCeramicProduct]"]', card)?.value;

            const data = {
              id: variant_id,
              quantity: 1,
              properties: {
                '_isCeramicProduct': isCeramicProduct
              }
            };

            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data) {
                  const currentCount = this.headerCart.innerText;
                  // const successActive = 'product-card__success--active';
                  this.headerCart.innerText = Number(currentCount) + 1;

                  // Émettre un événement pour déclencher l'ouverture de la popup
                  console.log('Émission de l\'événement cartItemAdded depuis product-card');
                  const event = new CustomEvent('cartItemAdded', {
                    detail: { source: 'product-card', data: data }
                  });
                  document.dispatchEvent(event);

                  // Fallback vers mm-cart si la popup n'est pas disponible après un délai
                  setTimeout(() => {
                    const popup = document.querySelector('[data-product-popup]');
                    if (!popup && typeof mmOpenCart === 'function') {
                      console.log('Popup non trouvée après délai, utilisation du fallback mmOpenCart');
                      mmOpenCart();
                    }
                  }, 100);

                  // success.classList.add(successActive);
                  // setTimeout(() => {
                  //   success.classList.remove(successActive);
                  // }, 1200);
                }
              })
              .catch((error) => {
                console.error(error);
              });
          });
      });
    }

    refreshMiniCart() {
      // Méthode dépréciée - utilise maintenant mm-cart
      if (typeof mmOpenAndRefreshCart === 'function') {
        mmOpenAndRefreshCart();
      }
    }

    cardWishlist() {
      this.cards.forEach((card) => {
        const wishlist = qs('.js-product-card-wishlist', card);
        const wishlistActive = 'product-card__wishlist--active';
        wishlist &&
          wishlist.addEventListener('click', (e) => {
            e.preventDefault();
            const el = e.currentTarget;
            if (el.classList.contains(wishlistActive)) {
              el.classList.remove(wishlistActive);
            } else {
              el.classList.add(wishlistActive);
            }
          });
      });
    }

    cardVariants() {
      let isVariantActiveClass = false;
      this.cards.forEach((card) => {
        const variants = qsa('.js-product-card-variant', card);

        variants &&
          variants.forEach((variant, index) => {
            let variant_id = variant.dataset.variantId;
            if(variant.classList.contains('product-card__variant-link--is-variant')) {
              if (variant.classList.contains('product-card__variant-link--active')) {
                this.updateVariant(variant, variant_id, card);
                isVariantActiveClass = true;
              }
            } else {
              if(index === 0) {
                this.updateVariant(variant, variant_id, card);
              }
            }


            variant.addEventListener('click', (e) => {
              e.preventDefault();
              const el = e.currentTarget;
              let current_variant_id = el.dataset.variantId;

              this.updateVariant(el, current_variant_id, card);
              this.priceLayout();
            });
          });
      });
    }

    updateVariant(el, variant_id, card) {
      const dataEl = qs(`.js-product-card-variant-${variant_id}`, card);
      const priceEl = qs('.js-product-card-price', card);
      const mainImageEl = qs('.js-product-card-image-default', card);
      const input = qs('input[name="id"]', card);
      const remainingItem = qs('.js-product-card__remaining-item', card);
      const remainingItemSpan = qs('.js-product-card__remaining-item span', card);
      const variantTitle = qs('.js-product-card__variant-title', card);
      const variantSubtitle = qs('.js-product-card__variant-subtitle', card);
      const variantLinks = qsa('.js-product-card__image, .js-product-card-name a, .product-card__addcart-link, .js-recipe-products__add-button', card);
      const variantActive = 'product-card__variant-link--active';

      const addCartBtn = qs('button.js-product-card-add', card);
      const addCartLink = qs('a.product-card__addcart-link', card);

      if(variantLinks) {
        variantLinks.forEach(link => {
          link.setAttribute('href', dataEl.dataset.itemUrl);
        })
      }

      const imgAttributes = {
        srcset: dataEl.dataset.variantImageSrcset || null,
        src: dataEl.dataset.variantImageSrc || null,
        alt: dataEl.dataset.variantImageAlt || null,
        height: dataEl.dataset.variantImageHeight || null,
        width: dataEl.dataset.variantImageWidth || null,
      };

      qsa('.js-product-card-variant', card).forEach((item) => {
        item.classList.remove(variantActive);
      });

      el.classList.add(variantActive);
       const originalPrice = dataEl.dataset.variantPriceMoney.replace('€', '');
      const comparePrice = dataEl.dataset.variantComparePriceMoney.replace('€', '');
      if(comparePrice == originalPrice)
      {
        priceEl.innerHTML = `${dataEl.dataset.variantPriceMoney}`;
      }
      else
      {
        priceEl.innerHTML = `
        <span>${dataEl.dataset.variantComparePriceMoney}</span>
        ${dataEl.dataset.variantPriceMoney} `;
      }




      if (remainingItem !== null) {
        if (parseInt(dataEl.dataset.remainingItem, 10) > 0 && parseInt(dataEl.dataset.remainingItem, 10) < 21) {
          if(parseInt(dataEl.dataset.remainingItem) > 1){
            remainingItem.innerHTML = `• En Stock - Plus que <span>${dataEl.dataset.remainingItem}</span> articles`;
          }else{
            remainingItem.innerHTML = `• En Stock - Plus que <span>${dataEl.dataset.remainingItem}</span> article`;
          }
          
          remainingItem.classList.remove('product-card__remaining-item--nostock');
          remainingItem.classList.remove('product-card__remaining-item--promo');
        } else if (parseInt(dataEl.dataset.remainingItem, 10) > 20) {
          remainingItem.innerHTML = `${dataEl.dataset.withStock}`;
          remainingItem.classList.remove('product-card__remaining-item--nostock');
          remainingItem.classList.remove('product-card__remaining-item--promo');
        } else if (parseFloat(comparePrice.replace(',', '.')) > parseFloat(originalPrice.replace(',', '.'))) {
          // remainingItem.innerHTML = `${dataEl.dataset.promo}`;
          // remainingItem.classList.add('product-card__remaining-item--promo');
          // remainingItem.classList.remove('product-card__remaining-item--nostock');
        } else {
          remainingItem.innerHTML = `${dataEl.dataset.outStock}`;
          remainingItem.classList.add('product-card__remaining-item--nostock');
          remainingItem.classList.remove('product-card__remaining-item--promo');
        }
      }

      variantTitle.innerHTML = `${dataEl.dataset.variantTitle}`;
      variantSubtitle.innerHTML = `${dataEl.dataset.variantSubtitle}`;


      qs('.js-product-card-badge-sale', card).innerHTML = ``;

      if (dataEl.dataset.showProductBadgeDiscount == 'true') {
        if (parseFloat(comparePrice.replace(',', '.')) > parseFloat(originalPrice.replace(',', '.'))) {
          qs(
            '.js-product-card-badge-sale',
            card
          ).innerHTML = `
            <span>-${100 - Math.round(((parseFloat(originalPrice.replace(',', '.')) / parseFloat(comparePrice.replace(',', '.'))) * 100))}%</span>
          `;
        }
      }

      if (input) {
        input.value = variant_id;
      }

      if (parseInt(dataEl.dataset.remainingItem, 10) > 0) {
        addCartBtn && addCartBtn.classList.remove('js-product-card-add--hidden');
        addCartLink && addCartLink.classList.add('product-card__addcart-link--hidden');
      } else {
        addCartBtn && addCartBtn.classList.add('js-product-card-add--hidden');
        addCartLink && addCartLink.classList.remove('product-card__addcart-link--hidden');
      }

      Object.keys(imgAttributes).forEach((attr) => {
        if (imgAttributes['src'] !== null) {
          mainImageEl.setAttribute(attr, imgAttributes[attr]);
        }
      });
    }

    priceLayout() {
      this.cards.forEach((card) => {
        const prices = qsa('.js-product-card-price', card);

        prices && prices.forEach((price, index) => {
          if (price && price.querySelector('span')) {
            let priceDiscount = price && price.querySelector('span').textContent;
            let priceCut = price && price.innerText.slice(0, -5).replace(priceDiscount, '');

            if(priceDiscount === '') {
              price.classList.remove('product-card__price--discounted');
            } else {
              price.classList.add('product-card__price--discounted');
            }
            price.innerHTML= `<span class="product-card__price-compare">${priceDiscount}</span> ${priceCut}${price.innerText.slice(-5)}`
          }
        })
      });
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
})();
